import { Loader2 } from "lucide-react";
import Image, { ImageProps } from "next/image";
import { useState } from "react";

const ImageWithLoader = ({
  loaderImage,
  className,
  onLoadingComplete,
  ...props
}: { loaderImage?: string } & ImageProps) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && (
        <>
          <Image
            {...props}
            src={loaderImage ?? "/properties/building-low.jpg"}
            alt="Loading image"
            className={[className, "blur-md"].filter(Boolean).join(" ")}
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <Loader2 className="animate-spin " stroke="#BF1E64" />
          </div>
        </>
      )}
      <Image
        {...props}
        className={className}
        onLoadingComplete={(result) => {
          setLoaded(true);
          onLoadingComplete?.(result);
        }}
      />
    </>
  );
};

export default ImageWithLoader;
